<script>
    import constants from '@/constants';

    export default {
        computed: {
            filterType() {return constants.FILTER_TYPE},
        }
    }
</script>


<template>
    <label
        v-for="(filterTypeValue, filterTypeIndex) in filterType" :key="filterTypeIndex"
    >* {{ filterTypeValue['name'] }} - {{ filterTypeValue['description'] }}</label>
</template>